import { getScopedItem, STORAGE_KEYS } from "../components/common/Helper";
import APIConstants from "./APIConstants";
import APIService from "./APIService";
import DebugService from "./DebugService";
import AzureAPIService, { setAzureAuthToken } from "./AzureAPIService";

/**
 * @description Security Scan Api Service
 */
const SecurityScanApiService = {

  scanAccount: async (data) => {
    try {
      const endpoint = APIConstants.ENDPOINT_SECURITY_SCAN

      return APIService.post(endpoint, data);
    } catch (err) {
      DebugService.error(`Security Scan Api Service: Error Caught while scanning account`, err)
      throw err;
    }
  },

  getScanReportList: async (selectedAccount) => {
    try {
      let url = APIConstants.ENDPOINT_SECURITY_SCAN_REPORT_LIST

      if (selectedAccount) {
        url += `?userAccountId=${selectedAccount}`
      }

      return await APIService.get(url)
    } catch (err) {
      DebugService.error(`Security Scan Api Service: Error Caught while fetching scanned report list`, err)
    }
  },

  getScanReport: async ({selectedAccount,openSearchId}) => {
    try {
      let url = APIConstants.ENDPOINT_SECURITY_SCAN_REPORT
      
      if (openSearchId) {
        url += `?openSearchId=${openSearchId}`
      }

      if (selectedAccount) {
        url += `&userAccountId=${selectedAccount}`
      }

      return await APIService.get(url)
    } catch (err) {
      DebugService.error(`Security Scan Api Service: Error Caught while fetching scanned report`, err)
    }
  },


  // =============================================
  // Azure APIs
  // =============================================
  scanAzureAccount: async (data) => {
    try {
      const endpoint = APIConstants.ENDPOINT_SECURITY_SCAN
      // let SECURITY_SCAN_URL = (process.env.NODE_ENV === 'development' || process.env.REACT_APP_ENV === 'staging')
      //   ? process.env.REACT_APP_SECURITY_SCAN_STAGING_URL
      //   : process.env.REACT_APP_SECURITY_SCAN_URL;

      // SECURITY_SCAN_URL = SECURITY_SCAN_URL + endpoint;

      // const response = await axios.post(SECURITY_SCAN_URL, dataRequest, {
      //   headers: AxiosService.defaults.headers.common,
      // });

      // if(response.data['error'] && response.data['error']['code'] === 401) {
      //   window.location.href = '/sign-in?reason=unauthorized'
      // }

      // return response.data;
      if (getScopedItem(STORAGE_KEYS.LOCAL_LOGIN_TOKEN)) {
        setAzureAuthToken(getScopedItem(STORAGE_KEYS.LOCAL_LOGIN_TOKEN))
      }

      return await AzureAPIService.post(endpoint, data)
    } catch (err) {
      DebugService.error(`Security Scan Api Service: Error Caught while scanning account`, err)
      throw err;
    }
  },

  getAzureScanReportList: async (selectedAccount) => {
    try {
      let url = APIConstants.ENDPOINT_SECURITY_SCAN_REPORT_LIST

      if (selectedAccount) {
        url += `?userAccountId=${selectedAccount}`
      }

      if (getScopedItem(STORAGE_KEYS.LOCAL_LOGIN_TOKEN)) {
        setAzureAuthToken(getScopedItem(STORAGE_KEYS.LOCAL_LOGIN_TOKEN))
      }

      return await AzureAPIService.get(url)
    } catch (err) {
      DebugService.error(`Security Scan Api Service: Error Caught while fetching scanned report list`, err)
    }
  },

  getAzureScanReport: async ({selectedAccount,openSearchId}) => {
    try {
      let url = APIConstants.ENDPOINT_SECURITY_SCAN_REPORT
      
      if (openSearchId) {
        url += `?openSearchId=${openSearchId}`
      }

      if (selectedAccount) {
        url += `&userAccountId=${selectedAccount}`
      }

      if (getScopedItem(STORAGE_KEYS.LOCAL_LOGIN_TOKEN)) {
        setAzureAuthToken(getScopedItem(STORAGE_KEYS.LOCAL_LOGIN_TOKEN))
      }

      return await AzureAPIService.get(url)
    } catch (err) {
      DebugService.error(`Security Scan Api Service: Error Caught while fetching scanned report`, err)
    }
  },
}

export default SecurityScanApiService;
